import { z } from "zod";
import { ErrorEnvelopeSchema, IsoDateTimeSchema } from "./primitives.js";
// POST /v1/plan-jobs request — no user_id; trigger context only.
export const PlanJobCreateRequestSchema = z.object({
    trigger: z.enum(["onboarding", "regeneration", "manual"]),
    /**
     * Step-6 correction (ADR-043): request-scoped optimization intent —
     * "make next week low-waste" / "maximum variety". Never persisted as a
     * user preference; safety, nutrition feasibility, and the hard budget
     * are untouched by it.
     */
    optimizationPriority: z.enum(["balanced", "low_waste", "high_variety"]).optional(),
});
export const PlanJobStatusSchema = z.enum([
    "queued",
    "running",
    "validating",
    "completed",
    "failed",
]);
export const PlanJobResponseSchema = z.object({
    id: z.string(),
    status: PlanJobStatusSchema,
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
    lastHeartbeatAt: IsoDateTimeSchema.nullable(),
    resultPlanId: z.string().nullable(),
    error: ErrorEnvelopeSchema.nullable(),
});
//# sourceMappingURL=planJobs.js.map